import styled from 'styled-components';

export const OrganizeEventCard = styled.div`
  padding: 50px 0;
  overflow: hidden;
  background-color: #${({ backgroundColor }) => backgroundColor};

  &.brg_sec {
    margin-top: 50px;
    background: ${({ backgroundColor }) => backgroundColor || '#f7f7f7'};
  }

  &.scnd_crd_orgevents {
    padding: 50px 0 0;
  }

  div[class*='SectionHeadlinestyled__SectionHeadline-'] {
    margin-bottom: 0;
  }

  &#imageCardsCarousel_3 {
    margin-top: 50px;
    @media (max-width: 575.98px) {
      margin-top: 30px;
    }
  }
  &#imageCardsCarousel_4,
  &#imageCardsCarousel_5 {
    padding-bottom: 0px;
  }

  &.exhibitcard_service {
    padding: 50px 0 0;
  }

  &.title_sm {
    &:nth-of-type(odd) {
      padding-top: 0px;
      padding-bottom: 0px;
    }

    .slick-dots {
      padding-top: 0px;
    }

    .venueorganise_heading {
      h2 {
        font-size: 20px;
        line-height: 30px;
        color: #000;
        font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif' : '')};
      }

      p {
        display: none;
        @media (min-width: 768px) {
          display: block;
        }
      }
    }
  }
`;
